import { type ReactNode, useId, type PropsWithChildren } from "react";
import { cn, Label } from "ui";

interface FieldWithLabelProps {
  label: ReactNode;
  renderField(id: string): ReactNode;
  className?: string;
  labelClassName?: string;
  fieldClassName?: string;
}

export function FieldWithLabel(props: PropsWithChildren<FieldWithLabelProps>) {
  const id = useId();

  return (
    <div className={cn("flex flex-col gap-2", props.className)}>
      <Label className={props.labelClassName} htmlFor={id}>
        {props.label}
      </Label>
      <div className={cn("min-w-0 flex-1", props.fieldClassName)}>
        {props.renderField(id)}
      </div>
    </div>
  );
}
